export default "/assets/images/hepa.bf57173939adebb0.png";